import React from 'react';
import PropTypes from 'prop-types';
import { unionSvg as UnionSvg } from 'theme/icon';
import dayjs from 'dayjs';
import cn from 'classnames';
import styles from './styles.scss';

const ChanceBlock = props => {
  const {
    data: { chance, isRnp, rnpDate, success, name },
    source,
  } = props;
  const title =
    source === 1
      ? `Вероятность победы рассчитана для ${name}. Изменить организацию Вы можете в своем Личном кабинете`
      : `Вероятность победы рассчитана для ${name}`;
  return (
    <div
      className={cn({
        [styles.wrapper]: true,
        [styles.successWrapper]: success && !isRnp,
        [styles.failWrapper]: success && isRnp,
      })}
    >
      {success && !isRnp && (
        <div className={styles.success} title={title}>
          <UnionSvg />
          <span className={styles.percent}>{chance}%</span>
          <div className={styles.chance}>
            <span className={styles.caption}>Вероятность победы</span>
            {chance < 45 && <span className={cn(styles.low, styles.level)}>Низкая</span>}
            {chance >= 45 && chance < 80 && <span className={cn(styles.middle, styles.level)}>Средняя</span>}
            {chance >= 80 && <span className={cn(styles.high, styles.level)}>Высокая</span>}
          </div>
        </div>
      )}
      {success && isRnp && (
        <div className={styles.fail} title={title}>
          Вы не можете участвовать в данной процедуре до
          <span className={styles.date}>{dayjs(rnpDate).format('DD.MM.YYYY')}</span>
          т.к. вы находитесь в РНП
        </div>
      )}
    </div>
  );
};

ChanceBlock.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  source: PropTypes.number.isRequired,
};
ChanceBlock.defaultProps = {};
export default ChanceBlock;
